import React from 'react';
import { Field } from 'redux-form';
import { Form, Row, Col, Avatar, Comment } from 'antd';
import AntIcon from '../../shared/components/AntIcon';

import {
  formItemLayout,
  formItemLayoutWithoutLabel,
  renderInput,
} from '../../shared/utils/form_components';

const CommentFields = ({ fields, label, deleteComment }) => {
  if (fields.length === 0) {
    return null;
  }

  return (
    <div>
      {fields.map((commentPath, index, fields) => {
        const commentId = fields.get(index)._id;

        const author = fields.get(index).author;

        return (
          <Form.Item
            {...(index === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
            key={commentPath}
            label={index === 0 ? label : null}
            className="comments-row"
          >
            <Row className="comments-row" align='bottom'>
              <Col span={21}>
                <Comment
                  author={author ? <span>{author.username}</span> : <span><i>Deleted user</i></span>}
                  avatar={
                    <Avatar
                      src="https://riabir.ru/wp-content/uploads/2019/10/avatar-images-free-download-4-1.png"
                      alt="Han Solo"
                    />
                  }
                  content={
                    <Field
                      inputOnly
                      name={`${commentPath}.message`}
                      placeholder="Comments"
                      component={renderInput}
                    />
                  }
                />
              </Col>
              <Col className="comments-span" span={3}>
                <AntIcon
                  type="minus-circle-o"
                  onClick={() => {
                    deleteComment(commentId)
                    fields.remove(index)
                  }}
                  style={{ cursor: 'pointer', color: 'red' }}
                />
              </Col>
            </Row>
          </Form.Item>
      )})}

      <Form.Item
        {...(fields.length === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
        label={fields.length === 0 ? label : null}
      >
      </Form.Item>
    </div>
  );
}

export default CommentFields;
